import React from 'react';
import { Table } from 'components/shared/Table';
import { VOTask } from '../../types';
import { createTableColumns } from '../constants';

interface Props {
  isLoading: boolean;
  tableData: VOTask[];
}

export const TasksTable = ({ isLoading, tableData }: Props) => {
  const columns = createTableColumns();

  return (
    <Table<VOTask> tableData={tableData} loading={isLoading} columns={columns} paginationOptions={{ pageSize: 5 }} />
  );
};
